import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var TimelineItem = function (props) {
    var dot = props.dot, dotStyle = props.dotStyle, className = props.className, children = props.children, customisedCls = props.prefixCls, otherProps = __rest(props, ["dot", "dotStyle", "className", "children", "prefixCls"]);
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('timeline-item', configContext.prefixCls, customisedCls);
    var cls = classNames(prefixCls, className);
    return (React.createElement("li", __assign({}, otherProps, { className: cls }),
        React.createElement("div", { className: prefixCls + "__head" },
            React.createElement("div", { className: prefixCls + "__dot-container" }, dot || React.createElement("span", { className: prefixCls + "__dot", style: dotStyle }))),
        React.createElement("div", { className: prefixCls + "__content" }, children)));
};
TimelineItem.displayName = 'TimelineItem';
export default TimelineItem;
//# sourceMappingURL=timeline-item.js.map